import { FC } from "react";

interface ScoreProps {
    score: string;
    firstHalfScore?: string;
}

export const Score: FC<ScoreProps> = ({
    score,
    firstHalfScore,
}) => {
    return (
        <div className="w-full text-center text-inherit box-border max-w-60 mx-auto font-semibold">
            <span className="text-6xl sm:text-9xl text-center">{score}</span>
            {!!firstHalfScore && <span className="block text-center">({firstHalfScore})</span>}
        </div>
    )
}